/**
 * fattureDaCorreggere.js — l'indirizzo dell'elenco «Da correggere» di tutti i
 * mesi, in un posto solo per chi lo scrive e per chi ci porta:
 *   - la pagina Fatture dello stile nuovo (pages/FatturazioneConsole.jsx), che
 *     legge ?filtro= e ?mese= dall'indirizzo e li scrive col filtro, con la
 *     tendina del periodo e con «Mostrali»;
 *   - il numero accanto alla voce Fatture del menu (navigazione/schermate.js,
 *     contatoreApre), che e' un collegamento suo (Alex, 7/10/2026, risposta
 *     B6: «numeri di Fatture e Agenda che aprono un elenco filtrato»).
 *
 * PERCHE' «TUTTI I MESI» E NON IL MESE DI OGGI. Il numero del menu conta i
 * documenti da correggere di ogni mese (contatoriController, chiave
 * 'fatture'); l'elenco, senza ?mese=, guarda il mese di oggi e dice a parte
 * quanti ce ne sono fuori («Mostrali»). Portato al solo filtro, chi clicca
 * «3» vedrebbe 1 riga e una frase: il numero direbbe una cosa e l'elenco
 * un'altra. Con ?mese=tutti il server non mette nessun periodo, e la vista
 * da_correggere di fatturazioneController e' la stessa condizione del numero:
 * tante righe quanto il numero (lo pretende provaContatori.js).
 *
 * Perche' una costante e non tre copie: la pagina tratta un valore che non
 * conosce come «niente» (il mese di oggi, nessun filtro). Con due copie, una
 * rinomina nella pagina avrebbe fatto portare il numero all'elenco del mese,
 * o a quello intero, senza un errore.
 *
 * Fuori da components/: la tabella delle schermate si carica anche in Node
 * (scripts/caricaSchermate.js), che di components/ accetta solo le pagine.
 */

/** Il valore di ?filtro= che accende «Da correggere» nella pagina Fatture
    (la chiave di VISTE in fatturazioneController e in FatturazioneConsole). */
export const FILTRO_DA_CORREGGERE = 'da_correggere';

/** Il valore di ?mese= che vuol dire «tutti i mesi»: nessun periodo. */
export const MESE_TUTTI = 'tutti';

/** L'elenco delle fatture da correggere di tutti i mesi. */
export const ELENCO_DA_CORREGGERE = `/fatturazione?mese=${MESE_TUTTI}&filtro=${FILTRO_DA_CORREGGERE}`;

/**
 * Il nome del numero accanto alla voce Fatture, per chi non lo vede (il
 * lettore di schermo) e per chi ci passa sopra col mouse.
 */
export const descriviNumeroDaCorreggere = (n) =>
    `${n} ${n === 1 ? 'documento' : 'documenti'} da correggere: apri l'elenco filtrato`;
